import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { ButtonCloseComponent } from '@components/button-close/button-close.component';
import { SFXDirective } from '@directives/sfx.directive';
import { canAnalyticsActivate } from '@helpers/engine';
import { setOption } from '@helpers/state-options';
import { shouldShowAnalyticsConsentBanner } from '@helpers/state-options.ui';

@Component({
  selector: 'app-banner-analytics-consent',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonCloseComponent, SFXDirective],
  templateUrl: './banner-analytics-consent.component.html',
  styleUrl: './banner-analytics-consent.component.scss',
})
export class BannerAnalyticsConsentComponent {
  public showBanner = computed(
    () => shouldShowAnalyticsConsentBanner() && canAnalyticsActivate(),
  );

  optIn(): void {
    setOption('analyticsEnabled', true);
    setOption('analyticsOptInDismissed', true);
  }

  dismiss(): void {
    setOption('analyticsOptInDismissed', true);
  }
}
